import { render, staticRenderFns } from "./familyTable.vue?vue&type=template&id=478c9eec&scoped=true"
import script from "./familyTable.vue?vue&type=script&lang=js"
export * from "./familyTable.vue?vue&type=script&lang=js"
import style0 from "./familyTable.vue?vue&type=style&index=0&id=478c9eec&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c9eec",
  null
  
)

export default component.exports